/**
 * ComboSystem — Consecutive hit combos reward skilled play.
 *
 * Each hit within 1.5s of previous increases combo counter.
 * Higher combo = more damage + visual flair.
 *
 * x1-2: no bonus
 * x3-5: +10% damage, "COMBO" text
 * x6-9: +25% damage, "¡GRAN COMBO!" text, golden
 * x10+: +50% damage, "¡COMBO LEGENDARIO!" text, flaming
 *
 * Combo breaks if no hit for 1.5s or player takes damage.
 */

export class ComboSystem {
  constructor() {
    this.count = 0;
    this.timer = 0;
    this.COMBO_WINDOW = 1.5;

    this._buildUI();
  }

  _buildUI() {
    this._display = document.createElement('div');
    this._display.style.cssText = `
      position:fixed; top:50%; left:70%; transform:translate(-50%, -50%);
      font-family:'Courier New',monospace; font-weight:bold;
      text-shadow:3px 3px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000;
      z-index:155; pointer-events:none; opacity:0;
      transition:opacity 0.3s, transform 0.3s;
    `;
    document.body.appendChild(this._display);
  }

  onHit() {
    this.count++;
    this.timer = this.COMBO_WINDOW;
    this._showCombo();
  }

  onPlayerHit() {
    this._breakCombo();
  }

  _breakCombo() {
    if (this.count >= 10 && this.onComboEnd) this.onComboEnd(this.count);
    this.count = 0;
    this.timer = 0;
    this._display.style.opacity = '0';
  }

  _showCombo() {
    if (this.count < 3) {
      this._display.style.opacity = '0';
      return;
    }
    let text, color, size;
    if (this.count >= 10) {
      text = `¡COMBO LEGENDARIO! x${this.count}`;
      color = '#FF4400';
      size = 32;
    } else if (this.count >= 6) {
      text = `¡GRAN COMBO! x${this.count}`;
      color = '#FFD700';
      size = 26;
    } else {
      text = `COMBO x${this.count}`;
      color = '#FFFFFF';
      size = 20;
    }
    this._display.textContent = text;
    this._display.style.color = color;
    this._display.style.fontSize = size + 'px';
    this._display.style.opacity = '1';
    // Pulse animation
    this._display.style.transform = 'translate(-50%, -50%) scale(1.2)';
    setTimeout(() => {
      this._display.style.transform = 'translate(-50%, -50%) scale(1)';
    }, 100);
  }

  getDamageMultiplier() {
    if (this.count >= 10) return 1.5;
    if (this.count >= 6) return 1.25;
    if (this.count >= 3) return 1.1;
    return 1.0;
  }

  update(dt) {
    if (this.count === 0) return;
    this.timer -= dt;
    if (this.timer <= 0) {
      this._breakCombo();
    }
  }
}
